import { useEffect } from "react";
import type { Appearance } from "@circle-react-shared/BuilderUI/Store/interfaceSlice";

export const useSystemAppearance = ({
  onAppearanceChange,
  isEnabled = true,
}: {
  onAppearanceChange: (appearance: Appearance) => void;
  isEnabled?: boolean;
}) => {
  useEffect(() => {
    if (!isEnabled) return;

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e: MediaQueryListEvent) => {
      onAppearanceChange(e.matches ? "dark" : "light");
    };

    onAppearanceChange(mediaQuery.matches ? "dark" : "light");
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [onAppearanceChange, isEnabled]);
};
